export default __webpack_public_path__ + "static/media/key.783416ec.gif";